(function () {
  const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  const ACCEPTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif'];
  const IMAGE_ACCEPT_ATTR = 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif';
  const UPLOAD_FORMAT_HINT = 'Supported formats: jpg, jpeg, png, webp · Maximum file size: 10 MB';
  const INVALID_IMAGE_FORMAT_MESSAGE = 'Invalid file format. Please upload a JPG, JPEG, PNG, or WEBP image.';
  const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;
  const MAX_ROOMS = 10;
  const MAX_WINDOWS_PER_ROOM = 5;
  const TEST_API_ORIGIN = 'https://api.twopagessmart.com';
  // const TEST_API_ORIGIN = 'https://dcs-web.photogrid.space';
  const DESIGN_PREVIEW_ENDPOINT = `${TEST_API_ORIGIN}/web/dcs/design-preview`;
  const SUBMIT_ENDPOINT = `${DESIGN_PREVIEW_ENDPOINT}/submit`;
  const PRESIGN_UPLOAD_ENDPOINT = `${TEST_API_ORIGIN}/web/file/presign-upload`;
  const UPLOAD_DIRECTORY = 'dcs';
  const DEFAULT_TONE_OPTIONS = [
    { name: 'Warm Neutrals (Ivory, Beige, Linen)', value: 'warm-neutrals', color: '#e4d8ca' },
    { name: 'Cool Neutrals (White, Grey, Slate)', value: 'cool-neutrals', color: '#d7d9d6' },
    { name: 'Earth Tones (Terracotta, Rust, Clay)', value: 'earth-tones', color: '#bd6547' },
    { name: 'Deep & Moody (Navy, Forest, Black)', value: 'deep-moody', color: '#20352d' },
    { name: 'Pastel & Soft (Blush, Sage, Sky)', value: 'pastel-soft', color: '#cbdcc9' },
    { name: 'Pattern & Print', value: 'pattern-print', color: '#f4eee8' },
    { name: "Not Sure - Designer's Choice", value: 'not-sure-designer-s-choice', color: '#f4eee8' },
    { name: 'Warm Whites', value: 'warm-whites', color: '#efe7dc' },
    { name: 'Soft Linen', value: 'soft-linen', color: '#e6d8c4' },
    { name: 'Muted Sage', value: 'muted-sage', color: '#c4d0bf' },
    { name: 'Dusty Clay', value: 'dusty-clay', color: '#c18b6d' },
    { name: 'Ink & Charcoal', value: 'ink-charcoal', color: '#2a2b2d' }
  ];
  const DEFAULT_TREATMENT_OPTIONS = [
    { name: 'Curtains & Drapes', value: 'curtains-drapes' },
    { name: 'Roman Shades', value: 'roman-shades' },
    { name: 'Roller Shades', value: 'roller-shades' },
    { name: 'Woven Shades', value: 'woven-shades' },
    { name: 'Valance / Cornice', value: 'valance-cornice' },
    { name: "Not Sure - Designer's Choice", value: 'not-sure-designer-s-choice' }
  ];
  const COUNTRY_LIST = [
    {code:"US",name:"United States",dial_code:"+1"},
    {code:"AF",name:"Afghanistan",dial_code:"+93"},
    {code:"AX",name:"Aland Islands",dial_code:"+358"},
    {code:"AL",name:"Albania",dial_code:"+355"},
    {code:"DZ",name:"Algeria",dial_code:"+213"},
    {code:"AS",name:"American Samoa",dial_code:"+1"},
    {code:"AD",name:"Andorra",dial_code:"+376"},
    {code:"AO",name:"Angola",dial_code:"+244"},
    {code:"AI",name:"Anguilla",dial_code:"+1"},
    {code:"AQ",name:"Antarctica",dial_code:""},
    {code:"AG",name:"Antigua and Barbuda",dial_code:"+1"},
    {code:"AR",name:"Argentina",dial_code:"+54"},
    {code:"AM",name:"Armenia",dial_code:"+374"},
    {code:"AW",name:"Aruba",dial_code:"+297"},
    {code:"AU",name:"Australia",dial_code:"+61"},
    {code:"AT",name:"Austria",dial_code:"+43"},
    {code:"AZ",name:"Azerbaijan",dial_code:"+994"},
    {code:"BS",name:"Bahamas",dial_code:"+1"},
    {code:"BH",name:"Bahrain",dial_code:"+973"},
    {code:"BD",name:"Bangladesh",dial_code:"+880"},
    {code:"BB",name:"Barbados",dial_code:"+1"},
    {code:"BY",name:"Belarus",dial_code:"+375"},
    {code:"BE",name:"Belgium",dial_code:"+32"},
    {code:"BZ",name:"Belize",dial_code:"+501"},
    {code:"BJ",name:"Benin",dial_code:"+229"},
    {code:"BM",name:"Bermuda",dial_code:"+1"},
    {code:"BT",name:"Bhutan",dial_code:"+975"},
    {code:"BO",name:"Bolivia",dial_code:"+591"},
    {code:"BQ",name:"Bonaire, Sint Eustatius and Saba",dial_code:"+599"},
    {code:"BA",name:"Bosnia and Herzegovina",dial_code:"+387"},
    {code:"BW",name:"Botswana",dial_code:"+267"},
    {code:"BV",name:"Bouvet Island",dial_code:""},
    {code:"BR",name:"Brazil",dial_code:"+55"},
    {code:"IO",name:"British Indian Ocean Territory",dial_code:"+246"},
    {code:"BN",name:"Brunei Darussalam",dial_code:"+673"},
    {code:"BG",name:"Bulgaria",dial_code:"+359"},
    {code:"BF",name:"Burkina Faso",dial_code:"+226"},
    {code:"BI",name:"Burundi",dial_code:"+257"},
    {code:"KH",name:"Cambodia",dial_code:"+855"},
    {code:"CM",name:"Cameroon",dial_code:"+237"},
    {code:"CA",name:"Canada",dial_code:"+1"},
    {code:"CV",name:"Cabo Verde",dial_code:"+238"},
    {code:"KY",name:"Cayman Islands",dial_code:"+1"},
    {code:"CF",name:"Central African Republic",dial_code:"+236"},
    {code:"TD",name:"Chad",dial_code:"+235"},
    {code:"CL",name:"Chile",dial_code:"+56"},
    {code:"CN",name:"China",dial_code:"+86"},
    {code:"CX",name:"Christmas Island",dial_code:"+61"},
    {code:"CC",name:"Cocos (Keeling) Islands",dial_code:"+61"},
    {code:"CO",name:"Colombia",dial_code:"+57"},
    {code:"KM",name:"Comoros",dial_code:"+269"},
    {code:"CG",name:"Congo",dial_code:"+242"},
    {code:"CD",name:"Congo, Democratic Republic of the",dial_code:"+243"},
    {code:"CK",name:"Cook Islands",dial_code:"+682"},
    {code:"CR",name:"Costa Rica",dial_code:"+506"},
    {code:"CI",name:"Côte d’Ivoire",dial_code:"+225"},
    {code:"HR",name:"Croatia",dial_code:"+385"},
    {code:"CU",name:"Cuba",dial_code:"+53"},
    {code:"CW",name:"Curaçao",dial_code:"+599"},
    {code:"CY",name:"Cyprus",dial_code:"+357"},
    {code:"CZ",name:"Czech Republic",dial_code:"+420"},
    {code:"DK",name:"Denmark",dial_code:"+45"},
    {code:"DJ",name:"Djibouti",dial_code:"+253"},
    {code:"DM",name:"Dominica",dial_code:"+1"},
    {code:"DO",name:"Dominican Republic",dial_code:"+1"},
    {code:"EC",name:"Ecuador",dial_code:"+593"},
    {code:"EG",name:"Egypt",dial_code:"+20"},
    {code:"SV",name:"El Salvador",dial_code:"+503"},
    {code:"GQ",name:"Equatorial Guinea",dial_code:"+240"},
    {code:"ER",name:"Eritrea",dial_code:"+291"},
    {code:"EE",name:"Estonia",dial_code:"+372"},
    {code:"SZ",name:"Eswatini",dial_code:"+268"},
    {code:"ET",name:"Ethiopia",dial_code:"+251"},
    {code:"FK",name:"Falkland Islands",dial_code:"+500"},
    {code:"FO",name:"Faroe Islands",dial_code:"+298"},
    {code:"FJ",name:"Fiji",dial_code:"+679"},
    {code:"FI",name:"Finland",dial_code:"+358"},
    {code:"FR",name:"France",dial_code:"+33"},
    {code:"GF",name:"French Guiana",dial_code:"+594"},
    {code:"PF",name:"French Polynesia",dial_code:"+689"},
    {code:"TF",name:"French Southern Territories",dial_code:""},
    {code:"GA",name:"Gabon",dial_code:"+241"},
    {code:"GM",name:"Gambia",dial_code:"+220"},
    {code:"GE",name:"Georgia",dial_code:"+995"},
    {code:"DE",name:"Germany",dial_code:"+49"},
    {code:"GH",name:"Ghana",dial_code:"+233"},
    {code:"GI",name:"Gibraltar",dial_code:"+350"},
    {code:"GR",name:"Greece",dial_code:"+30"},
    {code:"GL",name:"Greenland",dial_code:"+299"},
    {code:"GD",name:"Grenada",dial_code:"+1"},
    {code:"GP",name:"Guadeloupe",dial_code:"+590"},
    {code:"GU",name:"Guam",dial_code:"+1"},
    {code:"GT",name:"Guatemala",dial_code:"+502"},
    {code:"GG",name:"Guernsey",dial_code:"+44"},
    {code:"GN",name:"Guinea",dial_code:"+224"},
    {code:"GW",name:"Guinea-Bissau",dial_code:"+245"},
    {code:"GY",name:"Guyana",dial_code:"+592"},
    {code:"HT",name:"Haiti",dial_code:"+509"},
    {code:"HN",name:"Honduras",dial_code:"+504"},
    {code:"HK",name:"Hong Kong",dial_code:"+852"},
    {code:"HU",name:"Hungary",dial_code:"+36"},
    {code:"IS",name:"Iceland",dial_code:"+354"},
    {code:"IN",name:"India",dial_code:"+91"},
    {code:"ID",name:"Indonesia",dial_code:"+62"},
    {code:"IR",name:"Iran",dial_code:"+98"},
    {code:"IQ",name:"Iraq",dial_code:"+964"},
    {code:"IE",name:"Ireland",dial_code:"+353"},
    {code:"IM",name:"Isle of Man",dial_code:"+44"},
    {code:"IL",name:"Israel",dial_code:"+972"},
    {code:"IT",name:"Italy",dial_code:"+39"},
    {code:"JM",name:"Jamaica",dial_code:"+1"},
    {code:"JP",name:"Japan",dial_code:"+81"},
    {code:"JE",name:"Jersey",dial_code:"+44"},
    {code:"JO",name:"Jordan",dial_code:"+962"},
    {code:"KZ",name:"Kazakhstan",dial_code:"+7"},
    {code:"KE",name:"Kenya",dial_code:"+254"},
    {code:"KI",name:"Kiribati",dial_code:"+686"},
    {code:"KP",name:"Korea (North)",dial_code:"+850"},
    {code:"KR",name:"Korea (South)",dial_code:"+82"},
    {code:"KW",name:"Kuwait",dial_code:"+965"},
    {code:"KG",name:"Kyrgyzstan",dial_code:"+996"},
    {code:"LA",name:"Lao People's Democratic Republic",dial_code:"+856"},
    {code:"LV",name:"Latvia",dial_code:"+371"},
    {code:"LB",name:"Lebanon",dial_code:"+961"},
    {code:"LS",name:"Lesotho",dial_code:"+266"},
    {code:"LR",name:"Liberia",dial_code:"+231"},
    {code:"LY",name:"Libya",dial_code:"+218"},
    {code:"LI",name:"Liechtenstein",dial_code:"+423"},
    {code:"LT",name:"Lithuania",dial_code:"+370"},
    {code:"LU",name:"Luxembourg",dial_code:"+352"},
    {code:"MO",name:"Macao",dial_code:"+853"},
    {code:"MG",name:"Madagascar",dial_code:"+261"},
    {code:"MW",name:"Malawi",dial_code:"+265"},
    {code:"MY",name:"Malaysia",dial_code:"+60"},
    {code:"MV",name:"Maldives",dial_code:"+960"},
    {code:"ML",name:"Mali",dial_code:"+223"},
    {code:"MT",name:"Malta",dial_code:"+356"},
    {code:"MH",name:"Marshall Islands",dial_code:"+692"},
    {code:"MQ",name:"Martinique",dial_code:"+596"},
    {code:"MR",name:"Mauritania",dial_code:"+222"},
    {code:"MU",name:"Mauritius",dial_code:"+230"},
    {code:"YT",name:"Mayotte",dial_code:"+262"},
    {code:"MX",name:"Mexico",dial_code:"+52"},
    {code:"FM",name:"Micronesia",dial_code:"+691"},
    {code:"MD",name:"Moldova",dial_code:"+373"},
    {code:"MC",name:"Monaco",dial_code:"+377"},
    {code:"MN",name:"Mongolia",dial_code:"+976"},
    {code:"ME",name:"Montenegro",dial_code:"+382"},
    {code:"MS",name:"Montserrat",dial_code:"+1"},
    {code:"MA",name:"Morocco",dial_code:"+212"},
    {code:"MZ",name:"Mozambique",dial_code:"+258"},
    {code:"MM",name:"Myanmar",dial_code:"+95"},
    {code:"NA",name:"Namibia",dial_code:"+264"},
    {code:"NR",name:"Nauru",dial_code:"+674"},
    {code:"NP",name:"Nepal",dial_code:"+977"},
    {code:"NL",name:"Netherlands",dial_code:"+31"},
    {code:"NC",name:"New Caledonia",dial_code:"+687"},
    {code:"NZ",name:"New Zealand",dial_code:"+64"},
    {code:"NI",name:"Nicaragua",dial_code:"+505"},
    {code:"NE",name:"Niger",dial_code:"+227"},
    {code:"NG",name:"Nigeria",dial_code:"+234"},
    {code:"NU",name:"Niue",dial_code:"+683"},
    {code:"NF",name:"Norfolk Island",dial_code:"+672"},
    {code:"MK",name:"North Macedonia",dial_code:"+389"},
    {code:"MP",name:"Northern Mariana Islands",dial_code:"+1"},
    {code:"NO",name:"Norway",dial_code:"+47"},
    {code:"OM",name:"Oman",dial_code:"+968"},
    {code:"PK",name:"Pakistan",dial_code:"+92"},
    {code:"PW",name:"Palau",dial_code:"+680"},
    {code:"PS",name:"Palestine",dial_code:"+970"},
    {code:"PA",name:"Panama",dial_code:"+507"},
    {code:"PG",name:"Papua New Guinea",dial_code:"+675"},
    {code:"PY",name:"Paraguay",dial_code:"+595"},
    {code:"PE",name:"Peru",dial_code:"+51"},
    {code:"PH",name:"Philippines",dial_code:"+63"},
    {code:"PL",name:"Poland",dial_code:"+48"},
    {code:"PT",name:"Portugal",dial_code:"+351"},
    {code:"PR",name:"Puerto Rico",dial_code:"+1"},
    {code:"QA",name:"Qatar",dial_code:"+974"},
    {code:"RE",name:"Réunion",dial_code:"+262"},
    {code:"RO",name:"Romania",dial_code:"+40"},
    {code:"RU",name:"Russian Federation",dial_code:"+7"},
    {code:"RW",name:"Rwanda",dial_code:"+250"},
    {code:"SA",name:"Saudi Arabia",dial_code:"+966"},
    {code:"SG",name:"Singapore",dial_code:"+65"},
    {code:"ZA",name:"South Africa",dial_code:"+27"},
    {code:"ES",name:"Spain",dial_code:"+34"},
    {code:"SE",name:"Sweden",dial_code:"+46"},
    {code:"CH",name:"Switzerland",dial_code:"+41"},
    {code:"TW",name:"Taiwan",dial_code:"+886"},
    {code:"TH",name:"Thailand",dial_code:"+66"},
    {code:"TR",name:"Turkey",dial_code:"+90"},
    {code:"UA",name:"Ukraine",dial_code:"+380"},
    {code:"AE",name:"United Arab Emirates",dial_code:"+971"},
    {code:"GB",name:"United Kingdom",dial_code:"+44"},
    {code:"UY",name:"Uruguay",dial_code:"+598"},
    {code:"UZ",name:"Uzbekistan",dial_code:"+998"},
    {code:"VN",name:"Viet Nam",dial_code:"+84"},
    {code:"YE",name:"Yemen",dial_code:"+967"},
    {code:"ZM",name:"Zambia",dial_code:"+260"},
    {code:"ZW",name:"Zimbabwe",dial_code:"+263"}
  ];

  class CtmDcsSubmit extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-dcssubmit-form]');
      this.stage = this.querySelector('[data-dcssubmit-stage]');
      this.status = this.querySelector('[data-dcssubmit-status]');
      this.editCode = this.getEditCode();
      this.isEditMode = Boolean(this.editCode);
      this.endpoint = this.isEditMode ? this.resolveUpdateEndpoint() : this.resolveSubmitEndpoint();
      this.detailEndpoint = this.resolveDetailEndpoint();
      this.uploadEndpoint = this.resolveUploadEndpoint();
      this.shopId = this.dataset.shopId || (window.theme?.tps?.shopId) || '';
      this.homeUrl = this.dataset.homeUrl || '/';
      this.topPicksUrl = this.dataset.topPicksUrl || '/collections/best-sellers';
      this.sectionId = this.dataset.sectionId || '';
      this.visibleFields = this.readVisibleFields();
      this.dropdownOptions = {
        tones: this.readDropdownOptions('tones', DEFAULT_TONE_OPTIONS),
        treatment: this.readDropdownOptions('treatment', DEFAULT_TREATMENT_OPTIONS)
      };
      this.roomNameSuggestions = this.readRoomNameSuggestions();
      this.step = 1;
      this.isSubmitting = false;
      this.isLoadingDetail = false;
      this.submitStatus = '';
      this.detailId = null;
      this.idCounter = 0;
      this.openDropdown = null;
      this.activeRoomSuggestionRoomId = null;
      this.phoneCountryOpen = false;
      this.state = this.createInitialState();
      this.boundClick = this.handleClick.bind(this);
      this.boundPointerdown = this.handlePointerdown.bind(this);
      this.boundChange = this.handleChange.bind(this);
      this.boundInput = this.handleInput.bind(this);
      this.boundFocusout = this.handleFocusout.bind(this);
      this.boundKeydown = this.handleKeydown.bind(this);
      this.boundDocumentClick = this.handleDocumentClick.bind(this);

      this.addEventListener('click', this.boundClick);
      this.addEventListener('pointerdown', this.boundPointerdown);
      this.addEventListener('change', this.boundChange);
      this.addEventListener('input', this.boundInput);
      this.addEventListener('focusout', this.boundFocusout);
      this.addEventListener('keydown', this.boundKeydown);
      document.addEventListener('click', this.boundDocumentClick);

      this.render();
      if (this.isEditMode) this.loadDetail();
    }

    resolveSubmitEndpoint() {
      const params = new URLSearchParams(window.location.search);
      const customEndpoint = params.get('dcs_endpoint')?.trim();
      return customEndpoint || SUBMIT_ENDPOINT;
    }

    resolveDetailEndpoint() {
      if (!this.editCode) return '';
      const params = new URLSearchParams(window.location.search);
      const customEndpoint = params.get('dcs_detail_endpoint')?.trim();
      return customEndpoint || `${DESIGN_PREVIEW_ENDPOINT}/detail/${encodeURIComponent(this.editCode)}`;
    }

    resolveUpdateEndpoint() {
      if (!this.editCode) return '';
      const params = new URLSearchParams(window.location.search);
      const customEndpoint = params.get('dcs_update_endpoint')?.trim();
      return customEndpoint || `${DESIGN_PREVIEW_ENDPOINT}/update/${encodeURIComponent(this.editCode)}`;
    }

    resolveUploadEndpoint() {
      const params = new URLSearchParams(window.location.search);
      const customEndpoint = params.get('dcs_upload_endpoint')?.trim();
      return customEndpoint || PRESIGN_UPLOAD_ENDPOINT;
    }

    getEditCode() {
      const params = new URLSearchParams(window.location.search);
      return params.get('session')?.trim() || '';
    }

    readVisibleFields() {
      return {
        lastName: this.readBooleanDataset('showLastName', true),
        phone: this.readBooleanDataset('showPhone', true),
        inspirationPhotos: this.readBooleanDataset('showInspirationPhotos', true),
        projectNotes: this.readBooleanDataset('showProjectNotes', true),
        measuringHelp: this.readBooleanDataset('showMeasuringHelp', true)
      };
    }

    readBooleanDataset(key, fallback = true) {
      const value = this.dataset[key];
      if (value === undefined) return fallback;
      return value === 'true';
    }

    getDropdowns() {
      return [
        {
          key: 'treatment',
          label: 'Treatment Type',
          icon: 'panel',
          options: this.dropdownOptions.treatment
        },
        {
          key: 'tones',
          label: 'Preferred Colors',
          icon: 'palette',
          options: this.dropdownOptions.tones
        }
      ];
    }

    readDropdownOptions(key, fallback) {
      const script = this.querySelector(`[data-dcssubmit-dropdown-options="${key}"]`);
      if (script?.textContent) {
        try {
          const parsed = JSON.parse(script.textContent);
          if (Array.isArray(parsed)) {
            const normalized = parsed
              .map((item) => ({
                name: String(item?.name || item?.label || '').trim(),
                value: String(item?.value || item?.name || item?.label || '').trim(),
                color: String(item?.color || '').trim()
              }))
              .filter((item) => item.name && item.value);

            if (normalized.length) return normalized;
          }
        } catch (error) {
          console.warn(`Failed to parse dropdown options for ${key}.`, error);
        }
      }

      return fallback;
    }

    readRoomNameSuggestions() {
      const script = this.querySelector('[data-dcssubmit-room-suggestions]');
      if (script?.textContent) {
        try {
          const parsed = JSON.parse(script.textContent);
          if (Array.isArray(parsed)) {
            const normalized = parsed
              .map((item) => String(item || '').trim())
              .filter(Boolean);
            if (normalized.length) return normalized;
          }
        } catch (error) {
          console.warn('Failed to parse room name suggestions.', error);
        }
      }

      return [
        'Living Room',
        'Bedroom',
        'Primary Bedroom',
        'Guest Bedroom',
        'Dining Room',
        'Kitchen',
        'Breakfast Nook',
        'Family Room',
        'Great Room',
        'Office',
        'Study',
        'Bathroom',
        'Powder Room',
        'Laundry Room',
        'Nursery',
        'Sunroom',
        'Basement',
        'Media Room'
      ];
    }

    disconnectedCallback() {
      this.revokeObjectUrls();
      this.removeEventListener('click', this.boundClick);
      this.removeEventListener('pointerdown', this.boundPointerdown);
      this.removeEventListener('change', this.boundChange);
      this.removeEventListener('input', this.boundInput);
      this.removeEventListener('focusout', this.boundFocusout);
      this.removeEventListener('keydown', this.boundKeydown);
      document.removeEventListener('click', this.boundDocumentClick);
    }

    createInitialState() {
      return {
        customer: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          phoneCountry: 'US',
          phoneDialCode: '+1'
        },
        phoneCountryOpen: false,
        rooms: [
          this.createRoom()
        ],
        inspiration: [],
        projectNotes: '',
        services: {
          inHome: false,
          zoom: false
        },
        socialPermission: 'yes',
        errors: {}
      };
    }

    createRoom() {
      return {
        id: this.nextId('room'),
        name: '',
        isExisting: false,
        windows: [
          this.createWindow()
        ]
      };
    }

    createWindow() {
      return {
        id: this.nextId('window'),
        isExisting: false,
        photo: null,
        photoUrl: '',
        uploadedPhotoUrl: '',
        isUploading: false,
        uploadPromise: null,
        tones: '',
        treatment: ''
      };
    }

    nextId(prefix) {
      this.idCounter += 1;
      return `${prefix}-${Date.now()}-${this.idCounter}`;
    }

    render() {
      this.classList.toggle('is-editing', this.isEditMode);
      this.updateProgress();
      if (!this.stage) return;

      if (this.step === 1) {
        this.stage.innerHTML = this.renderStepOne();
      } else if (this.step === 2) {
        this.stage.innerHTML = this.renderStepTwo();
      } else {
        this.stage.innerHTML = this.renderSuccess();
      }

      this.restoreFormValues();
      this.syncLoadingState();
    }

    renderStepOne() {
      const canAddRoom = this.state.rooms.length < MAX_ROOMS;
      const firstNameLabel = this.visibleFields.lastName ? 'First Name *' : 'Full Name *';
      const customerFields = [
        this.renderField('firstName', firstNameLabel, 'text', 'customer.firstName'),
        this.visibleFields.lastName ? this.renderField('lastName', 'Last Name', 'text', 'customer.lastName') : '',
        this.renderField('email', 'Email *', 'email', 'customer.email'),
        this.visibleFields.phone ? this.renderPhoneField('Phone Number *') : ''
      ].filter(Boolean).join('');
      const customerGridClass = !this.visibleFields.lastName && this.visibleFields.phone ? ' is-compact-contact' : '';
      return `
        <div class="ctm-dcssubmit_panel" data-dcssubmit-panel="1">
          <div class="ctm-dcssubmit_head">
            <span class="ctm-dcssubmit_headicon" aria-hidden="true">${this.cameraIcon()}</span>
            <div>
              <h2 class="ctm-dcssubmit_title" tabindex="-1" data-dcssubmit-heading>Start with a Photo of Your Window.</h2>
              <p class="ctm-dcssubmit_subtxt">Follow our photo tips for the best preview.</p>
            </div>
          </div>
          <div class="ctm-dcssubmit_grid${customerGridClass}">
            ${customerFields}
          </div>
        </div>
        ${this.isLoadingDetail ? `
          <div class="ctm-dcssubmit_loading" role="status">
            <span class="ctm-dcssubmit_overlayspinner" aria-hidden="true"></span>
            <span>Loading design details...</span>
          </div>
        ` : ''}
        <div class="ctm-dcssubmit_rooms">
          ${this.state.rooms.map((room, roomIndex) => this.renderRoom(room, roomIndex)).join('')}
        </div>
        <div class="ctm-dcssubmit_roomact">
          <button class="ctm-dcssubmit_btn ctm-dcssubmit_btn-wide" type="button" data-dcssubmit-add-room ${canAddRoom ? '' : 'disabled aria-disabled="true"'}>
            <span aria-hidden="true">+</span> Add Another Room
          </button>
        </div>
        ${this.visibleFields.inspirationPhotos ? `
          <div class="ctm-dcssubmit_inspo">
            <h2 class="ctm-dcssubmit_inspottl">Inspiration Photos (Optional)</h2>
            ${this.renderUpload('inspiration', 'Upload inspiration photos', this.state.inspiration, 'inspiration', { multiple: true })}
          </div>
        ` : ''}
        <div class="ctm-dcssubmit_nav">
          <button class="ctm-dcssubmit_btn" type="button" ${this.isEditMode ? 'data-dcssubmit-submit' : 'data-dcssubmit-next'} ${this.isLoadingDetail ? 'disabled aria-disabled="true"' : ''}>${this.isEditMode ? this.getSubmitButtonText() : 'Next'}</button>
        </div>
      `;
    }

    renderStepTwo() {
      const showStep2Grid = this.visibleFields.projectNotes || this.visibleFields.measuringHelp;
      return `
        <div class="ctm-dcssubmit_panel ctm-dcssubmit_panel-step2" data-dcssubmit-panel="2">
          <div class="ctm-dcssubmit_head">
            <span class="ctm-dcssubmit_headicon" aria-hidden="true">${this.editIcon()}</span>
            <div>
              <h2 class="ctm-dcssubmit_title" tabindex="-1" data-dcssubmit-heading>Anything Else We Should Know?</h2>
              <p class="ctm-dcssubmit_subtxt">Share your style preferences, functional needs, or any special requests.</p>
            </div>
          </div>
          ${showStep2Grid ? `
            <div class="ctm-dcssubmit_step2grid ${!this.visibleFields.projectNotes || !this.visibleFields.measuringHelp ? 'is-single' : ''}">
              ${this.visibleFields.projectNotes ? `
                <div class="ctm-dcssubmit_textarea-wrap">
                  <label class="ctm-dcssubmit_lbl" for="dcs-project-notes">Tell Us About Your Project & Preferred Products (Optional)</label>
                  <span class="ctm-dcssubmit_hint">e.g., Liz, Jawara, Patti</span>
                  <textarea class="ctm-dcssubmit_textarea" id="dcs-project-notes" data-dcssubmit-bind="projectNotes"></textarea>
                </div>
              ` : ''}
              ${this.visibleFields.measuringHelp ? `
                <fieldset class="ctm-dcssubmit_service">
                  <legend class="ctm-dcssubmit_lbl">Need Expert Help with Measuring? (Optional)</legend>
                  ${this.renderService('inHome', 'In-Home Measurement Service', 'Professional in-home measurement (select areas, paid service).', this.homeIcon())}
                  ${this.renderService('zoom', 'Zoom Measuring Consultation', 'A specialist helps you measure your windows live.', this.videoIcon())}
                </fieldset>
              ` : ''}
            </div>
          ` : ''}
          <fieldset class="ctm-dcssubmit_social">
            <legend class="ctm-dcssubmit_lbl">Do you allow TWOPAGES to feature your photos on social media?</legend>
            <label class="ctm-dcssubmit_radio">
              <input type="radio" name="socialPermission" value="yes" data-dcssubmit-social>
              <span>Yes</span>
            </label>
            <label class="ctm-dcssubmit_radio">
              <input type="radio" name="socialPermission" value="no" data-dcssubmit-social>
              <span>No</span>
            </label>
          </fieldset>
        </div>
        <div class="ctm-dcssubmit_nav ctm-dcssubmit_nav-two">
          <button class="ctm-dcssubmit_btn ctm-dcssubmit_btn-ghost" type="button" data-dcssubmit-back>Back</button>
          <button class="ctm-dcssubmit_btn" type="button" data-dcssubmit-submit>${this.getSubmitButtonText()}</button>
        </div>
      `;
    }

    getSubmitButtonText() {
      if (this.submitStatus === 'submitting') return 'Submitting...';
      return 'Submit';
    }

    renderSuccess() {
      return `
        <div class="ctm-dcssubmit_success">
          <div class="ctm-dcssubmit_success-icon" aria-hidden="true">${this.checkIcon()}</div>
          <h2 class="ctm-dcssubmit_success-title" tabindex="-1" data-dcssubmit-heading>Your Window Design Is Underway</h2>
          <p class="ctm-dcssubmit_success-copy">We'll email you within 48 hours with your personalized design recommendations and a preview of your windows.</p>
          <div class="ctm-dcssubmit_success-actions">
            ${this.isEditMode ? '' : '<button class="ctm-dcssubmit_btn ctm-dcssubmit_btn-ghost" type="button" data-dcssubmit-restart>Start Over</button>'}
            <a class="ctm-dcssubmit_btn" href="${this.escapeAttr(this.topPicksUrl)}">Explore Top Picks</a>
          </div>
        </div>
      `;
    }

    renderField(key, label, type, bind) {
      const error = this.state.errors[bind] || '';
      return `
        <div class="ctm-dcssubmit_field">
          <label class="ctm-dcssubmit_lbl" for="dcs-${key}">${label}</label>
          <input
            class="ctm-dcssubmit_input"
            id="dcs-${key}"
            type="${type}"
            maxlength="80"
            data-dcssubmit-bind="${bind}"
            aria-invalid="${error ? 'true' : 'false'}"
            ${error ? `aria-describedby="dcs-${key}-err"` : ''}
            ${this.readonlyAttr()}
          >
          ${error ? `<p class="ctm-dcssubmit_err" id="dcs-${key}-err">${error}</p>` : ''}
        </div>
      `;
    }

    renderPhoneField(label = 'Phone Number') {
      const error = this.state.errors['customer.phone'] || '';
      const country = this.getPhoneCountry();
      const countryData = this.getPhoneCountryData(country);
      const phoneInputId = `dcs-phone-${this.sectionId}`;
      const phoneCountryMenuId = `dcs-phone-country-menu-${this.sectionId}`;
      const phoneCountryTriggerId = `dcs-phone-country-trigger-${this.sectionId}`;
      const isPhoneCountryOpen = Boolean(this.phoneCountryOpen);
      return `
        <div class="ctm-dcssubmit_field ctm-dcssubmit_field-phone">
          <label class="ctm-dcssubmit_lbl" for="${phoneInputId}">${label}</label>
          <div class="ctm-dcssubmit_phonewrap">
            <div class="ctm-dcssubmit_phonefield">
              <button
                class="ctm-dcssubmit_phonebtn"
                type="button"
                id="${phoneCountryTriggerId}"
                data-dcssubmit-phone-trigger
                aria-haspopup="listbox"
                aria-expanded="${isPhoneCountryOpen ? 'true' : 'false'}"
                aria-controls="${phoneCountryMenuId}"
                ${this.isEditMode ? 'disabled aria-disabled="true"' : ''}
              >
                <span class="ctm-dcssubmit_phoneflagwrap" aria-hidden="true">
                  <img class="ctm-dcssubmit_phoneflag" alt="" width="20" height="14" src="${this.phoneFlagUrl(countryData.code)}">
                </span>
                <span class="ctm-dcssubmit_phonedial" data-dcssubmit-phone-dial>${countryData.dial_code}</span>
                <span class="ctm-dcssubmit_phonechev" aria-hidden="true">${this.chevronIcon()}</span>
              </button>
              <input
                class="ctm-dcssubmit_input ctm-dcssubmit_phoneinput"
                id="${phoneInputId}"
                type="tel"
                inputmode="numeric"
                autocomplete="tel"
                pattern="[0-9]*"
                placeholder="Enter your phone"
                data-dcssubmit-bind="customer.phone"
                aria-invalid="${error ? 'true' : 'false'}"
                ${error ? `aria-describedby="dcs-phone-err"` : ''}
                ${this.readonlyAttr()}
              >
            </div>
            <div class="ctm-dcssubmit_phonepanel ${isPhoneCountryOpen ? 'is-open' : ''}" id="${phoneCountryMenuId}" role="listbox" aria-label="Phone number country">
              ${COUNTRY_LIST.map((item) => {
                const selected = item.code === country;
                return `
                  <button
                    class="ctm-dcssubmit_phoneopt ${selected ? 'is-selected' : ''}"
                    type="button"
                    role="option"
                    aria-selected="${selected ? 'true' : 'false'}"
                    data-dcssubmit-phone-option
                    data-country-code="${item.code}"
                  >
                    <span class="ctm-dcssubmit_phoneoptflag" aria-hidden="true">
                      <img src="${this.phoneFlagUrl(item.code)}" alt="" width="20" height="14">
                    </span>
                    <span class="ctm-dcssubmit_phoneoptname">${item.name}</span>
                    <span class="ctm-dcssubmit_phoneoptdial">${item.dial_code}</span>
                    ${selected ? `<span class="ctm-dcssubmit_phoneoptcheck" aria-hidden="true">${this.checkIcon()}</span>` : ''}
                  </button>
                `;
              }).join('')}
            </div>
          </div>
          ${error ? `<p class="ctm-dcssubmit_err" id="dcs-phone-err">${error}</p>` : ''}
        </div>
      `;
    }

    renderRoom(room, roomIndex) {
      const roomNumber = roomIndex + 1;
      const roomError = this.state.errors[`room.${room.id}.name`] || '';
      const canRemoveRoom = this.state.rooms.length > 1;
      const canAddWindow = room.windows.length < MAX_WINDOWS_PER_ROOM;
      const roomBg = roomIndex % 2 === 0 ? '#FCFBFA' : '#FCF8F5';
      const shouldShowRoomSuggestions = this.activeRoomSuggestionRoomId === room.id
        && document.activeElement?.dataset?.dcssubmitRoomName === room.id;
      const roomSuggestions = shouldShowRoomSuggestions ? this.getRoomNameSuggestions(room.id, room.name) : [];
      return `
        <section class="ctm-dcssubmit_room" aria-labelledby="dcs-room-${room.id}-title" style="background-color: ${roomBg};">
          <div class="ctm-dcssubmit_roomhead">
            <span class="ctm-dcssubmit_num" aria-hidden="true">${roomNumber}</span>
            <h2 class="ctm-dcssubmit_roomttl" id="dcs-room-${room.id}-title">Room ${roomNumber}</h2>
            ${canRemoveRoom ? `<button class="ctm-dcssubmit_del ctm-dcssubmit_roomdel" type="button" data-dcssubmit-remove-room="${room.id}" aria-label="Remove Room ${roomNumber}">${this.trashIcon()}</button>` : ''}
          </div>
          <div class="ctm-dcssubmit_roomfield">
            <label class="ctm-dcssubmit_sr" for="dcs-room-${room.id}">Room ${roomNumber} name</label>
            <input
              class="ctm-dcssubmit_input"
              id="dcs-room-${room.id}"
              placeholder="e.g., Living Room, Bedroom"
              maxlength="80"
              data-dcssubmit-room-name="${room.id}"
              autocomplete="off"
              aria-invalid="${roomError ? 'true' : 'false'}"
              ${roomError ? `aria-describedby="dcs-room-${room.id}-err"` : ''}
              aria-autocomplete="list"
              aria-haspopup="listbox"
              aria-expanded="${roomSuggestions.length ? 'true' : 'false'}"
              aria-controls="dcs-room-suggestions-${room.id}"
            >
            ${roomSuggestions.length ? `
              <div
                class="ctm-dcssubmit_roomsuggestions"
                id="dcs-room-suggestions-${room.id}"
                role="listbox"
                data-dcssubmit-room-suggestions-wrap="${room.id}"
              >
                ${roomSuggestions.map((suggestion) => `
                  <button
                    class="ctm-dcssubmit_roomsuggestion"
                    type="button"
                    role="option"
                    data-dcssubmit-room-suggestion
                    data-room-id="${room.id}"
                    data-room-value="${this.escapeAttr(suggestion)}"
                  >${suggestion}</button>
                `).join('')}
              </div>
            ` : ''}
            ${roomError ? `<p class="ctm-dcssubmit_err" id="dcs-room-${room.id}-err">${roomError}</p>` : ''}
          </div>
          <div class="ctm-dcssubmit_winlist">
            ${room.windows.map((windowItem, windowIndex) => this.renderWindow(room, roomIndex, windowItem, windowIndex)).join('')}
          </div>
          <button class="ctm-dcssubmit_btn ctm-dcssubmit_btn-wide" type="button" data-dcssubmit-add-window="${room.id}" ${canAddWindow ? '' : 'disabled aria-disabled="true"'}>
            <span aria-hidden="true">+</span> Add Another Window in This Room
          </button>
        </section>
      `;
    }

    renderWindow(room, roomIndex, windowItem, windowIndex) {
      const label = `Window ${roomIndex + 1}-${windowIndex + 1}`;
      const canRemove = room.windows.length > 1;
      const showDropdowns = Boolean(windowItem.uploadedPhotoUrl && !windowItem.isUploading);
      return `
        <article class="ctm-dcssubmit_win" aria-labelledby="dcs-window-${windowItem.id}-title">
          <div class="ctm-dcssubmit_winhead">
            <h3 class="ctm-dcssubmit_winttl" id="dcs-window-${windowItem.id}-title">${label}</h3>
            ${canRemove ? `<button class="ctm-dcssubmit_del" type="button" data-dcssubmit-remove-window="${room.id}:${windowItem.id}" aria-label="Remove ${label}">${this.trashIcon()}</button>` : ''}
          </div>
          <div class="ctm-dcssubmit_winbody ${showDropdowns ? 'has-details' : 'is-upload-only'}">
            ${this.renderUpload(windowItem.id, `${label} photo`, windowItem, `window.${windowItem.id}.photo`)}
            ${showDropdowns ? `
              <div class="ctm-dcssubmit_dropdowns">
                ${this.getDropdowns().map((dropdown) => this.renderDropdownField(windowItem, dropdown)).join('')}
              </div>
            ` : ''}
          </div>
        </article>
      `;
    }

    renderDropdownField(windowItem, dropdown) {
      const selected = windowItem[dropdown.key] || '';
      const dropdownId = `dcs-drop-${windowItem.id}-${dropdown.key}`;
      const errorKey = `window.${windowItem.id}.${dropdown.key}`;
      const error = this.state.errors[errorKey] || '';
      const isOpen = this.openDropdown === dropdownId;
      const selectedOption = dropdown.options.find((option) => (option.value || option.name || option.label) === selected);
      const selectedLabel = selectedOption?.name || selectedOption?.label || selected || '';
      const assistiveText = selectedLabel || error;
      const requiredHintId = `${dropdownId}-required`;
      const describedBy = error ? `${requiredHintId} ${dropdownId}-err` : requiredHintId;
      return `
        <div class="ctm-dcssubmit_drop ${isOpen ? 'is-open' : ''}">
          <button
            class="ctm-dcssubmit_dropbtn"
            type="button"
            data-dcssubmit-dropdown="${dropdownId}"
            data-window-id="${windowItem.id}"
            data-dropdown-key="${dropdown.key}"
            aria-expanded="${isOpen ? 'true' : 'false'}"
            aria-controls="${dropdownId}"
            aria-invalid="${error ? 'true' : 'false'}"
            aria-describedby="${describedBy}"
          >
            <span class="ctm-dcssubmit_dropico" aria-hidden="true">${this.dropdownIcon(dropdown.icon)}</span>
            <span class="ctm-dcssubmit_droptxtwrap">
              <span class="ctm-dcssubmit_droplabel">${dropdown.label} *</span>
            </span>
            <span class="ctm-dcssubmit_droptxt ${error ? 'is-error' : ''} ${assistiveText ? '' : 'is-empty'}" ${error ? `id="${dropdownId}-err"` : ''}>${assistiveText}</span>
            <span class="ctm-dcssubmit_arrow" aria-hidden="true">${this.chevronIcon()}</span>
          </button>
          <span class="ctm-dcssubmit_sr" id="${requiredHintId}">${dropdown.label} is required.</span>
          ${isOpen ? this.renderDropdownMenu(dropdownId, windowItem, dropdown) : ''}
        </div>
      `;
    }

    readonlyAttr() {
      return this.isEditMode ? 'readonly aria-readonly="true"' : '';
    }

    renderUpload(id, label, imageState, errorKey, options = {}) {
      const inputId = `dcs-upload-${id}`;
      const error = this.state.errors[errorKey] || '';
      if (options.multiple) return this.renderMultiUpload(id, label, imageState, errorKey, inputId, error);
      const hasPhoto = Boolean(imageState?.photoUrl);
      return `
        <div class="ctm-dcssubmit_upld">
          <input
            class="ctm-dcssubmit_file"
            id="${inputId}"
            type="file"
            accept="${IMAGE_ACCEPT_ATTR}"
            data-dcssubmit-file="${id}"
            aria-label="${label}"
            aria-describedby="${inputId}-hint ${error ? `${inputId}-err` : ''}"
          >
          <label
            class="ctm-dcssubmit_upldbox ${hasPhoto ? 'has-photo' : ''}"
            for="${inputId}"
            data-dcssubmit-file-trigger="${inputId}"
          >
            ${hasPhoto
              ? `<img class="ctm-dcssubmit_preview" src="${this.escapeAttr(imageState.photoUrl)}" alt="${label} preview">`
              : `<span class="ctm-dcssubmit_upldicon" aria-hidden="true">${this.uploadIcon()}</span><span class="ctm-dcssubmit_upldmain">Upload Photo</span><span class="ctm-dcssubmit_upldsub" id="${inputId}-hint">${UPLOAD_FORMAT_HINT}</span>`}
            ${hasPhoto && imageState?.isUploading ? `
              <span class="ctm-dcssubmit_replace is-uploading">
                  <span class="ctm-dcssubmit_loadingicon" aria-hidden="true"></span>
                  <span class="ctm-dcssubmit_sr">Uploading Photo...</span>
              </span>
            ` : ''}
            ${hasPhoto ? `
              <span class="ctm-dcssubmit_sr" id="${inputId}-hint">${UPLOAD_FORMAT_HINT}</span>
            ` : ''}
          </label>
          ${hasPhoto && !imageState?.isUploading ? `
            <label
              class="ctm-dcssubmit_replace ctm-dcssubmit_replace-below"
              for="${inputId}"
              data-dcssubmit-file-trigger="${inputId}"
            >Replace Photo</label>
          ` : ''}
          ${error ? `<p class="ctm-dcssubmit_err" id="${inputId}-err">${error}</p>` : ''}
        </div>
      `;
    }

    renderMultiUpload(id, label, photos = [], errorKey, inputId, error) {
      const hasPhotos = photos.length > 0;
      return `
        <div class="ctm-dcssubmit_upld ctm-dcssubmit_upld-multi">
          <input
            class="ctm-dcssubmit_file"
            id="${inputId}"
            type="file"
            accept="${IMAGE_ACCEPT_ATTR}"
            multiple
            data-dcssubmit-file="${id}"
            aria-label="${label}"
            aria-describedby="${inputId}-hint ${error ? `${inputId}-err` : ''}"
          >
          ${hasPhotos ? `
            <div class="ctm-dcssubmit_upldbox ctm-dcssubmit_upldbox-multi has-photo">
              <div class="ctm-dcssubmit_multigrid" aria-label="Selected inspiration photos">
                ${photos.map((photo) => this.renderMultiUploadItem(photo)).join('')}
              </div>
              <label
                class="ctm-dcssubmit_browse"
                for="${inputId}"
                data-dcssubmit-file-trigger="${inputId}"
              >Browse file</label>
              <span class="ctm-dcssubmit_sr" id="${inputId}-hint">${UPLOAD_FORMAT_HINT}</span>
            </div>
          ` : `
            <label
              class="ctm-dcssubmit_upldbox"
              for="${inputId}"
              data-dcssubmit-file-trigger="${inputId}"
            >
              <span class="ctm-dcssubmit_upldicon" aria-hidden="true">${this.uploadIcon()}</span>
              <span class="ctm-dcssubmit_upldmain">Upload Photo</span>
              <span class="ctm-dcssubmit_upldsub" id="${inputId}-hint">${UPLOAD_FORMAT_HINT}</span>
            </label>
          `}
          ${error ? `<p class="ctm-dcssubmit_err" id="${inputId}-err">${error}</p>` : ''}
        </div>
      `;
    }

    renderMultiUploadItem(photo) {
      return `
        <div class="ctm-dcssubmit_multiitem">
          <img class="ctm-dcssubmit_multipreview" src="${this.escapeAttr(photo.photoUrl)}" alt="${this.escapeAttr(photo.fileName || 'Inspiration photo')} preview">
          <div class="ctm-dcssubmit_multibar">
            <span class="ctm-dcssubmit_multiname">${this.escapeHtml(photo.fileName || 'Inspiration photo')}</span>
            <button
              class="ctm-dcssubmit_multiremove"
              type="button"
              aria-label="Remove ${this.escapeAttr(photo.fileName || 'inspiration photo')}"
              data-dcssubmit-remove-inspiration="${this.escapeAttr(photo.id)}"
            >×</button>
          </div>
          ${photo.isUploading ? `<span class="ctm-dcssubmit_multiuploading">Uploading...</span>` : ''}
        </div>
      `;
    }

    renderDropdownMenu(dropdownId, windowItem, dropdown) {
      return `
        <div class="ctm-dcssubmit_menu" id="${dropdownId}" role="listbox" aria-label="${dropdown.label}">
          ${dropdown.options.map((option, optionIndex) => {
            const optionValue = option.value || option.name || option.label;
            const optionLabel = option.name || option.label || optionValue;
            const selected = windowItem[dropdown.key] === optionValue;
            return `
              <button
                class="ctm-dcssubmit_opt ${selected ? 'is-selected' : ''}"
                type="button"
                role="option"
                aria-selected="${selected ? 'true' : 'false'}"
                data-dcssubmit-option
                data-window-id="${windowItem.id}"
                data-dropdown-key="${dropdown.key}"
                data-option-index="${optionIndex}"
              >
                <span class="ctm-dcssubmit_swatch" style="--ctm-dcssubmit-swatch: ${option.color || '#f4eee8'}" aria-hidden="true"></span>
                <span>${optionLabel}</span>
                ${selected ? `<span class="ctm-dcssubmit_optcheck" aria-hidden="true">${this.checkIcon()}</span>` : ''}
              </button>
            `;
          }).join('')}
        </div>
      `;
    }

    renderService(key, title, copy, icon) {
      return `
        <label class="ctm-dcssubmit_card">
          <span class="ctm-dcssubmit_cardico" aria-hidden="true">${icon}</span>
          <span class="ctm-dcssubmit_cardtxt">
            <span class="ctm-dcssubmit_cardttl">${title}</span>
            <span class="ctm-dcssubmit_cardcpy">${copy}</span>
          </span>
          <input type="checkbox" data-dcssubmit-service="${key}">
        </label>
      `;
    }

    restoreFormValues() {
      this.querySelectorAll('[data-dcssubmit-bind]').forEach((input) => {
        input.value = this.getByPath(input.dataset.dcssubmitBind) || '';
      });

      this.querySelectorAll('[data-dcssubmit-phone-country]').forEach((select) => {
        select.value = this.state.customer.phoneCountry || 'US';
      });

      this.querySelectorAll('[data-dcssubmit-room-name]').forEach((input) => {
        const room = this.findRoom(input.dataset.dcssubmitRoomName);
        input.value = room?.name || '';
      });

      this.querySelectorAll('[data-dcssubmit-service]').forEach((input) => {
        input.checked = Boolean(this.state.services[input.dataset.dcssubmitService]);
      });

      this.querySelectorAll('[data-dcssubmit-social]').forEach((input) => {
        input.checked = input.value === this.state.socialPermission;
      });

      this.syncPhoneCountryUI();

      const heading = this.querySelector('[data-dcssubmit-heading]');
      if (heading && this.shouldFocusHeading) {
        heading.focus({ preventScroll: true });
        this.shouldFocusHeading = false;
      }
    }

    handleClick(event) {
      if (this.isSubmitting) return;

      if (!event.target.closest('.ctm-dcssubmit_roomfield')) {
        this.closeRoomSuggestions();
      }

      const removeInspiration = event.target.closest('[data-dcssubmit-remove-inspiration]');
      if (removeInspiration) {
        event.preventDefault();
        const photoId = removeInspiration.dataset.dcssubmitRemoveInspiration;
        const photo = this.state.inspiration.find((item) => item.id === photoId);
        if (photo?.photoUrl) URL.revokeObjectURL(photo.photoUrl);
        this.state.inspiration = this.state.inspiration.filter((item) => item.id !== photoId);
        this.syncInspirationError();
        this.render();
        return;
      }

      const fileTrigger = event.target.closest('[data-dcssubmit-file-trigger]');
      if (fileTrigger) {
        const input = this.querySelector(`#${CSS.escape(fileTrigger.dataset.dcssubmitFileTrigger)}`);
        if (input) input.value = '';
        return;
      }

      const phoneTrigger = event.target.closest('[data-dcssubmit-phone-trigger]');
      const phoneOption = event.target.closest('[data-dcssubmit-phone-option]');
      const dropdownButton = event.target.closest('[data-dcssubmit-dropdown]');
      const dropdownOption = event.target.closest('[data-dcssubmit-option]');

      if (this.openDropdown && !dropdownButton && !dropdownOption && !phoneTrigger && !phoneOption) {
        this.closeDropdown();
      }

      if (dropdownButton) {
        event.preventDefault();
        this.openDropdown = this.openDropdown === dropdownButton.dataset.dcssubmitDropdown
          ? null
          : dropdownButton.dataset.dcssubmitDropdown;
        this.render();
        return;
      }

      if (dropdownOption) {
        event.preventDefault();
        const windowId = dropdownOption.dataset.windowId;
        const key = dropdownOption.dataset.dropdownKey;
        const optionIndex = Number(dropdownOption.dataset.optionIndex);
        const dropdown = this.getDropdowns().find((item) => item.key === key);
        const value = dropdown?.options[optionIndex]?.value || dropdown?.options[optionIndex]?.label;
        const windowItem = this.findWindow(windowId);
        if (windowItem && value) windowItem[key] = value;
        delete this.state.errors[`window.${windowId}.${key}`];
        this.closeDropdown();
        return;
      }

      if (phoneTrigger) {
        event.preventDefault();
        this.closeDropdown();
        this.phoneCountryOpen = !this.phoneCountryOpen;
        this.render();
        return;
      }

      if (phoneOption) {
        event.preventDefault();
        const countryData = this.getPhoneCountryData(phoneOption.dataset.countryCode);
        this.state.customer.phoneCountry = countryData.code;
        this.state.customer.phoneDialCode = countryData.dial_code;
        this.phoneCountryOpen = false;
        this.validatePhoneField({ onlyWhenFilled: true });
        this.render();
        return;
      }

      const addWindow = event.target.closest('[data-dcssubmit-add-window]');
      if (addWindow) {
        const room = this.findRoom(addWindow.dataset.dcssubmitAddWindow);
        if (room) {
          if (room.windows.length >= MAX_WINDOWS_PER_ROOM) return;
          room.windows.push(this.createWindow());
          this.render();
        }
        return;
      }

      const addRoom = event.target.closest('[data-dcssubmit-add-room]');
      if (addRoom) {
        if (this.state.rooms.length >= MAX_ROOMS) return;
        const room = this.createRoom();
        if (this.isEditMode) room.name = this.getNextEditRoomName();
        this.state.rooms.push(room);
        this.render();
        return;
      }

      const removeRoom = event.target.closest('[data-dcssubmit-remove-room]');
      if (removeRoom) {
        const roomId = removeRoom.dataset.dcssubmitRemoveRoom;
        if (this.state.rooms.length > 1) {
          const room = this.findRoom(roomId);
          if (room) {
            room.windows.forEach((windowItem) => {
              if (windowItem?.photoUrl) URL.revokeObjectURL(windowItem.photoUrl);
            });
            this.state.rooms = this.state.rooms.filter((item) => item.id !== roomId);
            this.render();
          }
        }
        return;
      }

      const removeWindow = event.target.closest('[data-dcssubmit-remove-window]');
      if (removeWindow) {
        const [roomId, windowId] = removeWindow.dataset.dcssubmitRemoveWindow.split(':');
        const room = this.findRoom(roomId);
        if (room && room.windows.length > 1) {
          const windowItem = room.windows.find((item) => item.id === windowId);
          if (windowItem?.photoUrl) URL.revokeObjectURL(windowItem.photoUrl);
          room.windows = room.windows.filter((item) => item.id !== windowId);
          this.render();
        }
        return;
      }

      if (event.target.closest('[data-dcssubmit-next]')) {
        if (this.validateStepOne()) {
          this.step = 2;
          this.shouldFocusHeading = true;
          this.render();
          this.scrollToFormStart();
        } else {
          this.focusFirstError();
        }
      }

      if (event.target.closest('[data-dcssubmit-back]')) {
        this.step = 1;
        this.shouldFocusHeading = true;
        this.render();
      }

      if (event.target.closest('[data-dcssubmit-restart]')) {
        this.resetFlow();
      }

      if (event.target.closest('[data-dcssubmit-submit]')) {
        this.submit();
      }
    }

    handlePointerdown(event) {
      if (this.isSubmitting) return;

      const roomSuggestion = event.target.closest('[data-dcssubmit-room-suggestion]');
      if (!roomSuggestion) return;

      event.preventDefault();
      const roomId = roomSuggestion.dataset.roomId;
      const value = roomSuggestion.dataset.roomValue || '';
      const room = this.findRoom(roomId);
      if (room) {
        room.name = value;
        delete this.state.errors[`room.${roomId}.name`];
        this.activeRoomSuggestionRoomId = null;
        this.updateRoomFieldUI(roomId);
        this.updateRoomSuggestionsUI(roomId, { forceHide: true });
      }
    }

    handleChange(event) {
      if (this.isSubmitting) return;

      const fileInput = event.target.closest('[data-dcssubmit-file]');
      if (fileInput) {
        this.handleFile(fileInput);
        return;
      }

      const serviceInput = event.target.closest('[data-dcssubmit-service]');
      if (serviceInput) {
        this.state.services[serviceInput.dataset.dcssubmitService] = serviceInput.checked;
        return;
      }

      const socialInput = event.target.closest('[data-dcssubmit-social]');
      if (socialInput) {
        this.state.socialPermission = socialInput.value;
        return;
      }

    }

    handleInput(event) {
      if (this.isSubmitting) return;

      const bindInput = event.target.closest('[data-dcssubmit-bind]');
      if (bindInput) {
        const bindKey = bindInput.dataset.dcssubmitBind;
        const value = bindKey === 'customer.phone' ? this.sanitizePhoneNumber(bindInput.value) : bindInput.value;
        if (bindInput.value !== value) bindInput.value = value;
        this.setByPath(bindKey, value);
        delete this.state.errors[bindKey];
        return;
      }

      const roomInput = event.target.closest('[data-dcssubmit-room-name]');
      if (roomInput) {
        const room = this.findRoom(roomInput.dataset.dcssubmitRoomName);
        if (room) room.name = roomInput.value;
        this.activeRoomSuggestionRoomId = roomInput.dataset.dcssubmitRoomName;
        delete this.state.errors[`room.${roomInput.dataset.dcssubmitRoomName}.name`];
        this.updateRoomSuggestionsUI(roomInput.dataset.dcssubmitRoomName);
      }
    }

    handleFocusout(event) {
      if (this.isSubmitting) return;

      const emailInput = event.target.closest('[data-dcssubmit-bind="customer.email"]');
      if (emailInput) {
        this.state.customer.email = emailInput.value;
        this.validateEmailField();
        this.render();
        return;
      }

      const phoneInput = event.target.closest('[data-dcssubmit-bind="customer.phone"]');
      if (phoneInput) {
        this.state.customer.phone = this.sanitizePhoneNumber(phoneInput.value);
        this.validatePhoneField();
        this.render();
        return;
      }

      const roomInput = event.target.closest('[data-dcssubmit-room-name]');
      if (!roomInput) return;

      const roomId = roomInput.dataset.dcssubmitRoomName;
      const room = this.findRoom(roomId);
      if (!room) return;

      room.name = roomInput.value;
      this.validateRoomNames();
      this.activeRoomSuggestionRoomId = null;
      this.updateRoomFieldUI(roomId);
      this.updateRoomSuggestionsUI(roomId, { forceHide: true });
    }

    handleKeydown(event) {
      if (this.isSubmitting) {
        event.preventDefault();
        return;
      }

      if (event.key === 'Escape' && this.openDropdown) {
        event.preventDefault();
        this.closeDropdown();
      }

      if (event.key === 'Escape' && this.phoneCountryOpen) {
        event.preventDefault();
        this.phoneCountryOpen = false;
        this.render();
      }
    }

    handleDocumentClick(event) {
      if (this.phoneCountryOpen && !event.target.closest('.ctm-dcssubmit_phonewrap')) {
        this.phoneCountryOpen = false;
        this.render();
      }

      if (!event.composedPath().includes(this)) {
        this.closeRoomSuggestions();
        this.closeDropdown();
      }
    }

    async loadDetail() {
      if (!this.detailEndpoint || this.isLoadingDetail) return;

      this.isLoadingDetail = true;
      this.announce('Loading design details.');
      this.render();

      try {
        const response = await fetch(this.detailEndpoint, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        });

        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const result = await response.json();
        if (result?.code !== undefined && result.code !== 200) {
          throw new Error(result?.message || 'Detail request failed.');
        }
        const detail = this.unwrapResponsePayload(result);
        this.applyDetailData(detail);
        this.announce('');
      } catch (error) {
        console.error('DCS detail load failed.', error);
        this.announce('We could not load this design request. Please refresh and try again.', true);
      } finally {
        this.isLoadingDetail = false;
        this.render();
      }
    }

    unwrapResponsePayload(result) {
      if (result?.data && typeof result.data === 'object') return result.data;
      if (result?.result && typeof result.result === 'object') return result.result;
      return result || {};
    }

    applyDetailData(detail = {}) {
      this.revokeObjectUrls();

      this.detailId = this.firstDefined(
        detail.id,
        detail.designPreviewId,
        detail.previewId,
        detail.detailId
      );

      this.state = this.createInitialState();
      this.state.customer.firstName = this.stringValue(this.firstDefined(detail.firstName, detail.fullName, detail.name));
      this.state.customer.lastName = this.stringValue(detail.lastName);
      this.state.customer.email = this.stringValue(detail.email);
      this.applyDetailPhone(this.stringValue(detail.phone));
      this.state.projectNotes = this.stringValue(this.firstDefined(detail.userPrefer, detail.projectNotes, detail.notes, detail.preferredProducts));
      this.state.socialPermission = Number(detail.photoUsageConsent) === 0 || detail.photoUsageConsent === false ? 'no' : 'yes';
      this.applyMeasuringHelpType(this.stringValue(this.firstDefined(detail.measuringHelpType, detail.measuringHelp)));

      const rooms = this.normalizeDetailRooms(detail);
      if (rooms.length) this.state.rooms = rooms;

      const inspirationUrls = this.normalizeUrlList(this.firstDefined(
        detail.homePhotoUrls,
        detail.inspirationPhotos,
        detail.inspirationPhotoUrls
      ));
      this.state.inspiration = inspirationUrls.map((url, index) => this.createExistingPhoto(url, `Inspiration photo ${index + 1}`));
      this.state.errors = {};
      this.step = 1;
    }

    applyDetailPhone(phoneValue) {
      const rawPhone = this.stringValue(phoneValue);
      if (!rawPhone) {
        this.state.customer.phone = '';
        return;
      }

      const compactPhone = rawPhone.replace(/\s+/g, '');
      if (!compactPhone.startsWith('+')) {
        this.state.customer.phone = rawPhone;
        return;
      }

      const matchedCountry = COUNTRY_LIST
        .filter((item) => item.dial_code && compactPhone.startsWith(item.dial_code))
        .sort((a, b) => b.dial_code.length - a.dial_code.length)[0];

      if (!matchedCountry) {
        this.state.customer.phone = rawPhone;
        return;
      }

      this.state.customer.phoneCountry = matchedCountry.code;
      this.state.customer.phoneDialCode = matchedCountry.dial_code;
      this.state.customer.phone = compactPhone.slice(matchedCountry.dial_code.length);
    }

    normalizeDetailRooms(detail) {
      const detailRooms = this.asArray(this.firstDefined(detail.rooms, detail.roomList, detail.roomInfos));

      if (!detailRooms.length) {
        const flatWindowUrl = this.stringValue(this.firstDefined(detail.windowsPhoto, detail.windowPhoto, detail.photoUrl));
        if (!flatWindowUrl) return [];
        const room = this.createRoom();
        room.isExisting = true;
        room.name = this.stringValue(this.firstDefined(detail.roomName, detail.room, 'Room 1'));
        room.windows = [this.createExistingWindow(detail, 0)];
        return [room];
      }

      return detailRooms.map((roomDetail, roomIndex) => {
        const room = this.createRoom();
        room.isExisting = true;
        room.name = this.stringValue(this.firstDefined(roomDetail.roomName, roomDetail.name, roomDetail.room, `Room ${roomIndex + 1}`));
        const windowDetails = this.asArray(this.firstDefined(roomDetail.windows, roomDetail.windowList, roomDetail.windowInfos));
        room.windows = windowDetails.length
          ? windowDetails.map((windowDetail, windowIndex) => this.createExistingWindow(windowDetail, windowIndex))
          : [this.createExistingWindow(roomDetail, 0)];
        return room;
      });
    }

    createExistingWindow(windowDetail = {}, windowIndex = 0) {
      const windowItem = this.createWindow();
      const photoUrl = this.stringValue(this.firstDefined(
        windowDetail.windowsPhoto,
        windowDetail.windowPhoto,
        windowDetail.photoUrl,
        windowDetail.imageUrl,
        windowDetail.url
      ));
      windowItem.photo = null;
      windowItem.photoUrl = photoUrl;
      windowItem.uploadedPhotoUrl = photoUrl;
      windowItem.isUploading = false;
      windowItem.uploadPromise = null;
      windowItem.tones = this.normalizeDropdownValue('tones', this.firstDefined(windowDetail.desiredTones, windowDetail.tones, windowDetail.tone));
      windowItem.treatment = this.normalizeDropdownValue('treatment', this.firstDefined(windowDetail.treatmentType, windowDetail.treatment));
      windowItem.existingIndex = windowIndex;
      windowItem.isExisting = true;
      return windowItem;
    }

    getNextEditRoomName() {
      const existingNames = new Set(this.state.rooms.map((room) => room.name.trim().toLowerCase()).filter(Boolean));
      for (let index = this.state.rooms.length + 1; index <= MAX_ROOMS; index += 1) {
        const candidate = `Room ${index}`;
        if (!existingNames.has(candidate.toLowerCase())) return candidate;
      }
      return `Room ${Date.now()}`;
    }

    createExistingPhoto(url, fileName = 'Photo') {
      return {
        id: this.nextId('inspiration'),
        photo: null,
        photoUrl: url,
        uploadedPhotoUrl: url,
        isUploading: false,
        uploadPromise: null,
        fileName
      };
    }

    normalizeUrlList(value) {
      if (Array.isArray(value)) {
        return value
          .map((item) => this.stringValue(typeof item === 'object' ? this.firstDefined(item.url, item.photoUrl, item.fileUrl) : item))
          .filter(Boolean);
      }

      const stringValue = this.stringValue(value);
      if (!stringValue) return [];
      if (stringValue.startsWith('[')) {
        try {
          return this.normalizeUrlList(JSON.parse(stringValue));
        } catch (error) {
          return [];
        }
      }
      return stringValue.split(',').map((item) => item.trim()).filter(Boolean);
    }

    normalizeDropdownValue(key, value) {
      const normalizedValue = this.stringValue(value);
      if (!normalizedValue) return '';

      const matchedOption = this.dropdownOptions[key]?.find((item) => (
        item.value === normalizedValue || item.name === normalizedValue || item.label === normalizedValue
      ));

      return matchedOption?.value || normalizedValue;
    }

    applyMeasuringHelpType(value) {
      const normalizedValue = value.toLowerCase();
      this.state.services.inHome = normalizedValue.includes('in_home') || normalizedValue.includes('in-home');
      this.state.services.zoom = normalizedValue.includes('web_zoom') || normalizedValue.includes('zoom');
    }

    asArray(value) {
      if (Array.isArray(value)) return value;
      if (value && typeof value === 'object') return [value];
      if (typeof value === 'string' && value.trim()) {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed;
          if (parsed && typeof parsed === 'object') return [parsed];
          return [];
        } catch (error) {
          return [];
        }
      }
      return [];
    }

    firstDefined(...values) {
      return values.find((value) => value !== undefined && value !== null);
    }

    stringValue(value) {
      return value === undefined || value === null ? '' : String(value).trim();
    }

    async handleFile(input) {
      this.closeRoomSuggestions();
      const id = input.dataset.dcssubmitFile;
      const key = id === 'inspiration' ? 'inspiration' : `window.${id}.photo`;
      const selectedFiles = Array.from(input.files || []);

      if (id === 'inspiration') {
        this.handleInspirationFiles(selectedFiles, key);
        return;
      }

      const selectedFile = selectedFiles[0];

      if (!selectedFile) return;
      if (!this.isAcceptedImageFile(selectedFile)) {
        this.state.errors[key] = 'Upload a JPG, JPEG, PNG, WEBP, HEIC, or HEIF image.';
        this.render();
        this.focusFirstError();
        return;
      }

      let file = selectedFile;
      try {
        file = await this.prepareUploadFile(selectedFile);
      } catch (error) {
        this.state.errors[key] = error?.message || 'We could not process this image. Please try a different file.';
        this.render();
        this.focusFirstError();
        return;
      }

      const target = this.findWindow(id);
      if (!target) return;

      if (target.photoUrl) URL.revokeObjectURL(target.photoUrl);

      const photoData = {
        photo: file,
        photoUrl: URL.createObjectURL(file),
        uploadedPhotoUrl: '',
        isUploading: true,
        uploadPromise: null
      };

      target.photo = file;
      target.photoUrl = photoData.photoUrl;
      target.uploadedPhotoUrl = '';
      target.isUploading = true;

      delete this.state.errors[key];
      this.render();
      target.uploadPromise = this.uploadSelectedFile(id, key, file);
      await target.uploadPromise;
    }

    async handleInspirationFiles(selectedFiles, key) {
      if (!selectedFiles.length) return;

      const invalidFile = selectedFiles.find((file) => !this.isAcceptedImageFile(file));
      if (invalidFile) {
        this.state.errors[key] = 'Upload JPG, JPEG, PNG, WEBP, HEIC, or HEIF images.';
        this.render();
        this.focusFirstError();
        return;
      }

      let preparedFiles = [];
      try {
        preparedFiles = await Promise.all(selectedFiles.map((file) => this.prepareUploadFile(file)));
      } catch (error) {
        this.state.errors[key] = error?.message || 'We could not process one of these images. Please try different files.';
        this.render();
        this.focusFirstError();
        return;
      }

      const photoData = preparedFiles.map((file) => ({
        id: this.nextId('inspiration'),
        photo: file,
        photoUrl: URL.createObjectURL(file),
        uploadedPhotoUrl: '',
        isUploading: true,
        uploadPromise: null,
        fileName: file.name || 'Inspiration photo'
      }));

      this.state.inspiration = [...this.state.inspiration, ...photoData];
      delete this.state.errors[key];
      this.render();

      photoData.forEach((photo) => {
        photo.uploadPromise = this.uploadInspirationPhoto(photo, key);
      });

      await Promise.all(photoData.map((photo) => photo.uploadPromise));
    }

    async prepareUploadFile(file) {
      file = await this.normalizeUploadImageFile(file);

      if (file.size <= MAX_UPLOAD_SIZE_BYTES) return file;

      if (typeof imageCompression !== 'function') {
        throw new Error('Image compression library is not available.');
      }

      const compressedBlob = await imageCompression(file, {
        maxSizeMB: 10,
        useWebWorker: true,
        initialQuality: 0.9,
        alwaysKeepResolution: false
      });

      if (!compressedBlob) {
        throw new Error('Image compression failed.');
      }

      if (compressedBlob.size > MAX_UPLOAD_SIZE_BYTES) {
        throw new Error('This image is still larger than 10 MB after compression. Please upload a smaller image.');
      }

      if (compressedBlob instanceof File) {
        return this.normalizeUploadImageFile(compressedBlob);
      }

      const extension = this.fileExtensionForType(compressedBlob.type || file.type);
      const fileName = this.renameFileWithExtension(file.name, extension);
      const preparedFile = new File([compressedBlob], fileName, {
        type: compressedBlob.type || file.type,
        lastModified: Date.now()
      });

      return this.normalizeUploadImageFile(preparedFile);
    }

    isAcceptedImageFile(file) {
      const type = String(file?.type || '').toLowerCase();
      if (ACCEPTED_IMAGE_TYPES.includes(type)) return true;

      const extension = this.fileExtensionFromName(file?.name);
      return ACCEPTED_IMAGE_EXTENSIONS.includes(extension);
    }

    async normalizeUploadImageFile(file) {
      if (!window.TpsUploadImageNormalizer?.normalizeUploadImageFile) {
        throw new Error(INVALID_IMAGE_FORMAT_MESSAGE);
      }

      return window.TpsUploadImageNormalizer.normalizeUploadImageFile(file, {
        invalidFormatMessage: INVALID_IMAGE_FORMAT_MESSAGE
      });
    }

    fileExtensionForType(type) {
      switch (type) {
        case 'image/jpeg':
          return 'jpg';
        case 'image/png':
          return 'png';
        case 'image/webp':
          return 'webp';
        default:
          return 'jpg';
      }
    }

    fileExtensionFromName(fileName) {
      const matchedExtension = String(fileName || '').toLowerCase().match(/\.([a-z0-9]+)$/);
      return matchedExtension ? matchedExtension[1] : '';
    }

    renameFileWithExtension(fileName, extension) {
      const baseName = String(fileName || 'upload').replace(/\.[^.]+$/, '') || 'upload';
      return `${baseName}.${extension}`;
    }

    normalizeFileNameExtension(fileName) {
      const safeName = String(fileName || 'upload').trim() || 'upload';
      const matchedExtension = safeName.match(/\.([a-z0-9]+)$/i);
      if (!matchedExtension) return safeName;

      const baseName = safeName.slice(0, matchedExtension.index).replace(/\.+$/, '') || 'upload';
      return `${baseName}.${matchedExtension[1].toLowerCase()}`;
    }

    async uploadSelectedFile(id, errorKey, file) {
      const target = this.findWindow(id);
      if (!target || target.photo !== file) return;

      try {
        const fileUrl = await this.uploadFileToStorage(file);
        const currentTarget = this.findWindow(id);
        if (!currentTarget || currentTarget.photo !== file) return;

        currentTarget.uploadedPhotoUrl = fileUrl;
        currentTarget.isUploading = false;
        currentTarget.uploadPromise = null;
        delete this.state.errors[errorKey];
      } catch (error) {
        console.error('DCS photo upload failed.', error);
        const currentTarget = this.findWindow(id);
        if (!currentTarget || currentTarget.photo !== file) return;

        currentTarget.uploadedPhotoUrl = '';
        currentTarget.isUploading = false;
        currentTarget.uploadPromise = null;
        this.state.errors[errorKey] = error?.message || 'We could not upload this photo. Please try again.';
      }

      this.render();
    }

    async uploadInspirationPhoto(photo, errorKey) {
      if (!this.state.inspiration.includes(photo)) return;

      try {
        const fileUrl = await this.uploadFileToStorage(photo.photo);
        if (!this.state.inspiration.includes(photo)) return;

        photo.uploadedPhotoUrl = fileUrl;
        photo.isUploading = false;
        photo.uploadPromise = null;
        this.syncInspirationError();
      } catch (error) {
        console.error('DCS inspiration photo upload failed.', error);
        if (!this.state.inspiration.includes(photo)) return;

        photo.uploadedPhotoUrl = '';
        photo.isUploading = false;
        photo.uploadPromise = null;
        this.state.errors[errorKey] = error?.message || 'We could not upload one of these photos. Please remove it or try again.';
      }

      this.render();
    }

    syncInspirationError() {
      const error = this.getPhotoUploadError(this.state.inspiration, false);
      if (error) {
        this.state.errors.inspiration = error;
      } else {
        delete this.state.errors.inspiration;
      }
    }

    validateStepOne() {
      const errors = {};
      const customer = this.state.customer;

      if (!customer.firstName.trim()) {
        errors['customer.firstName'] = this.visibleFields.lastName ? 'Enter your first name.' : 'Enter your full name.';
      }
      const emailError = this.getEmailError();
      if (emailError) errors['customer.email'] = emailError;
      const phoneError = this.visibleFields.phone ? this.getPhoneError() : '';
      if (phoneError) errors['customer.phone'] = phoneError;

      this.state.rooms.forEach((room) => {
        room.windows.forEach((windowItem) => {
          const photoError = this.getPhotoUploadError(windowItem, true);
          if (photoError) errors[`window.${windowItem.id}.photo`] = photoError;

          if (!String(windowItem.treatment || '').trim()) {
            errors[`window.${windowItem.id}.treatment`] = 'Select a treatment type.';
          }
          if (!String(windowItem.tones || '').trim()) {
            errors[`window.${windowItem.id}.tones`] = 'Select your desired tones.';
          }
        });
      });

      if (this.visibleFields.inspirationPhotos) {
        const inspirationError = this.getPhotoUploadError(this.state.inspiration, false);
        if (inspirationError) errors.inspiration = inspirationError;
      }

      Object.assign(errors, this.collectRoomNameErrors());

      this.state.errors = errors;
      this.render();
      return Object.keys(errors).length === 0;
    }

    getPhotoUploadError(imageState, isRequired) {
      if (Array.isArray(imageState)) {
        if (!imageState.length) return isRequired ? 'Upload a window photo.' : '';
        if (imageState.some((item) => item.isUploading)) return 'Please wait for these photos to finish uploading.';
        if (imageState.some((item) => !item.uploadedPhotoUrl)) return 'Storage upload failed. Please remove the failed photo or try again.';
        return '';
      }
      if (!imageState?.photo && !imageState?.uploadedPhotoUrl) return isRequired ? 'Upload a window photo.' : '';
      if (imageState.isUploading) return 'Please wait for this photo to finish uploading.';
      if (!imageState.uploadedPhotoUrl) return 'Storage upload failed. Please replace this photo and try again.';
      return '';
    }

    collectRoomNameErrors() {
      const errors = {};
      const roomNameMap = new Map();

      this.state.rooms.forEach((room) => {
        const normalizedRoomName = room.name.trim().toLowerCase();
        if (!normalizedRoomName) {
          errors[`room.${room.id}.name`] = 'Enter a room name.';
          return;
        }

        const matchedRooms = roomNameMap.get(normalizedRoomName) || [];
        matchedRooms.push(room.id);
        roomNameMap.set(normalizedRoomName, matchedRooms);
      });

      roomNameMap.forEach((roomIds) => {
        if (roomIds.length > 1) {
          roomIds.forEach((roomId) => {
            errors[`room.${roomId}.name`] = 'Room names must be unique.';
          });
        }
      });

      return errors;
    }

    getEmailError() {
      const email = this.state.customer.email.trim();
      if (!email) return 'Enter your email.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Enter a valid email address.';
      return '';
    }

    validateEmailField() {
      delete this.state.errors['customer.email'];
      const emailError = this.getEmailError();
      if (emailError) this.state.errors['customer.email'] = emailError;
      return !emailError;
    }

    getPhoneError() {
      const phone = String(this.state.customer.phone || '').trim();
      if (!phone) return 'Enter your phone number.';
      return /^\d+$/.test(phone) ? '' : 'Enter numbers only.';
    }

    validatePhoneField({ onlyWhenFilled = false } = {}) {
      delete this.state.errors['customer.phone'];

      if (onlyWhenFilled && !this.state.customer.phone.trim()) return true;

      const phoneError = this.getPhoneError();
      if (phoneError) this.state.errors['customer.phone'] = phoneError;
      return !phoneError;
    }

    validateRoomNames() {
      const roomNameErrors = this.collectRoomNameErrors();

      this.state.rooms.forEach((room) => {
        const key = `room.${room.id}.name`;
        delete this.state.errors[key];
      });

      Object.assign(this.state.errors, roomNameErrors);
      return Object.keys(roomNameErrors).length === 0;
    }

    async submit() {
      if (this.isSubmitting) return;
      if (this.isEditMode && (this.detailId === undefined || this.detailId === null || this.detailId === '')) {
        this.announce('Design detail is still missing an ID. Please refresh and try again.', true);
        return;
      }

      if (!this.validateStepOne()) {
        this.step = 1;
        this.render();
        this.focusFirstError();
        return;
      }

      if (!this.endpoint) {
        this.announce('Submit endpoint is not configured.', true);
        return;
      }

      if (!this.arePhotosReadyForSubmit()) return;

      this.isSubmitting = true;
      this.submitStatus = 'submitting';
      this.announce('Submitting your design request.');
      this.render();

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.buildSubmitPayload())
        });

        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        this.step = 3;
        this.shouldFocusHeading = true;
        this.announce('');
        this.render();
        if (!this.isEditMode) {
          if (Shopify?.analytics) {
            Shopify.analytics.publish('dcs_submit_success', {});
          }
        }
      } catch (error) {
        this.announce('We could not submit your request. Please try again.', true);
      } finally {
        this.isSubmitting = false;
        this.submitStatus = '';
        if (this.step !== 3) this.render();
      }
    }

    arePhotosReadyForSubmit() {
      if (!this.validateStepOne()) {
        this.step = 1;
        this.render();
        this.focusFirstError();
        this.announce('Please finish uploading your photos before submitting.', true);
        return false;
      }

      return true;
    }

    buildSubmitPayload() {
      const payload = {
        shopId: String(this.shopId || ''),
        firstName: this.state.customer.firstName.trim(),
        lastName: this.visibleFields.lastName ? this.state.customer.lastName.trim() : '',
        email: this.state.customer.email.trim(),
        phone: this.visibleFields.phone ? this.getSubmitPhoneNumber() : '',
        rooms: this.state.rooms.map((room, roomIndex) => ({
          roomName: room.name.trim(),
          windows: room.windows.map((windowItem, windowIndex) => {
            const windowPayload = {
              windowRef: this.buildWindowRef(room.name, roomIndex, windowIndex),
              windowsPhoto: windowItem.uploadedPhotoUrl || '',
              desiredTones: this.getDropdownOptionLabel('tones', windowItem.tones),
              treatmentType: this.getDropdownOptionLabel('treatment', windowItem.treatment)
            };

            return windowPayload;
          })
        })),
        homePhotoUrls: this.visibleFields.inspirationPhotos
          ? this.state.inspiration
            .map((photo) => photo.uploadedPhotoUrl)
            .filter(Boolean)
          : [],
        photoUsageConsent: this.state.socialPermission === 'yes' ? 1 : 0,
        measuringHelpType: this.getMeasuringHelpType(),
        referralCode: this.getReferralCode(),
        preferredProducts: '',
        userPrefer: this.visibleFields.projectNotes ? this.state.projectNotes.trim() : ''
      };

      if (this.isEditMode) payload.id = this.detailId;

      return payload;
    }

    async uploadFileToStorage(file) {
      file = await this.normalizeUploadImageFile(file);
      const normalizedFileName = this.normalizeFileNameExtension(file.name || 'upload');

      const presignResponse = await fetch(this.uploadEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          fileName: normalizedFileName,
          contentType: file.type,
          businessType: UPLOAD_DIRECTORY
        })
      });

      if (!presignResponse.ok) {
        const message = await this.readResponseError(presignResponse);
        throw new Error(message || `Upload presign failed: ${presignResponse.status}`);
      }

      const presignResult = await presignResponse.json();
      const uploadData = presignResult?.data || {};

      if (presignResult?.code !== 200) {
        throw new Error(presignResult?.message || 'Upload presign failed.');
      }
      if (!uploadData.uploadUrl || !uploadData.fileUrl) {
        throw new Error('Upload presign response is missing uploadUrl or fileUrl.');
      }

      const uploadHeaders = {
        ...(uploadData.headers || {}),
        'Content-Type': uploadData.headers?.['Content-Type'] || file.type
      };

      const uploadResponse = await fetch(uploadData.uploadUrl, {
        method: uploadData.method || 'PUT',
        headers: uploadHeaders,
        body: file
      });

      if (!uploadResponse.ok) {
        const message = await this.readResponseError(uploadResponse);
        throw new Error(message || `Storage upload failed: ${uploadResponse.status}`);
      }

      return uploadData.fileUrl;
    }

    async readResponseError(response) {
      try {
        const text = await response.text();
        return text ? `${response.status} ${text}` : '';
      } catch (error) {
        return '';
      }
    }

    getDropdownOptionLabel(key, value) {
      const option = this.dropdownOptions[key]?.find((item) => item.value === value);
      return option?.name || value || '';
    }

    buildWindowRef(roomName, roomIndex, windowIndex) {
      const normalizedRoomName = String(roomName || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');

      const roomRef = normalizedRoomName || `room_${roomIndex + 1}`;
      return `${roomRef}_${windowIndex + 1}`;
    }

    getMeasuringHelpType() {
      if (!this.visibleFields.measuringHelp) return '';
      const selectedTypes = [];
      if (this.state.services.inHome) selectedTypes.push('in_home');
      if (this.state.services.zoom) selectedTypes.push('web_zoom');
      return selectedTypes.join(',');
    }

    getReferralCode() {
      const search = window.location?.search || '';
      if (!search) return '';

      const params = new URLSearchParams(search);
      const directValue = params.get('referralCode');
      if (directValue !== null) return directValue.trim();

      for (const [key, value] of params.entries()) {
        if (key.trim() === 'referralCode') return String(value || '').trim();
      }

      return '';
    }

    getSubmitPhoneNumber() {
      const phone = this.sanitizePhoneNumber(this.state.customer.phone);
      if (!phone) return '';
      if (phone.startsWith('+')) return phone;

      const dialCode = this.getPhoneCountryData(this.getPhoneCountry())?.dial_code || this.state.customer.phoneDialCode || '';
      return dialCode ? `${dialCode} ${phone}` : phone;
    }

    updateProgress() {
      this.querySelectorAll('[data-dcssubmit-progress]').forEach((item) => {
        const itemStep = Number(item.dataset.dcssubmitProgress);
        item.classList.toggle('is-active', this.step === itemStep);
        item.classList.toggle('is-complete', this.step > itemStep);
        item.setAttribute('aria-current', this.step === itemStep ? 'step' : 'false');
        const dot = item.querySelector('.ctm-dcssubmit_progdot');
        if (dot && this.step > itemStep) dot.innerHTML = this.checkIcon();
        if (dot && this.step <= itemStep) dot.textContent = String(itemStep);
      });
    }

    getPhoneCountry() {
      return this.state.customer.phoneCountry || 'US';
    }

    getPhoneCountryData(countryCode) {
      return COUNTRY_LIST.find((item) => item.code === countryCode) || COUNTRY_LIST[0];
    }

    sanitizePhoneNumber(value) {
      return String(value || '').replace(/\D/g, '');
    }

    phoneFlagUrl(countryCode) {
      return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`;
    }

    syncPhoneCountryUI() {
      const phoneContainer = this.querySelector('.ctm-dcssubmit_phonewrap');
      const flag = phoneContainer?.querySelector('.ctm-dcssubmit_phoneflag');
      const dialCode = phoneContainer?.querySelector('[data-dcssubmit-phone-dial]');
      const phoneInput = this.querySelector('[data-dcssubmit-bind="customer.phone"]');
      const countryData = this.getPhoneCountryData(this.getPhoneCountry());

      if (flag) {
        flag.src = this.phoneFlagUrl(countryData.code);
        flag.alt = countryData.name;
      }
      if (dialCode) dialCode.textContent = countryData.dial_code;
      if (phoneInput) {
        phoneInput.style.paddingLeft = '';
      }
    }

    focusFirstError() {
      requestAnimationFrame(() => {
        const errorField = this.querySelector('[aria-invalid="true"], .ctm-dcssubmit_err');
        const focusTarget = errorField?.matches('[aria-invalid="true"]')
          ? errorField
          : errorField?.previousElementSibling;
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: false });
        }
      });
    }

    scrollToFormStart() {
      requestAnimationFrame(() => {
        const target = this.form || this;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: Math.max(targetTop - 16, 0),
          behavior: 'smooth'
        });
      });
    }

    closeDropdown() {
      if (!this.openDropdown) return;
      this.openDropdown = null;
      this.render();
    }

    getRoomNameSuggestions(roomId, query) {
      const normalizedQuery = String(query || '').trim().toLowerCase();
      if (!normalizedQuery) return [];
      if (this.activeRoomSuggestionRoomId && this.activeRoomSuggestionRoomId !== roomId) return [];

      return this.roomNameSuggestions
        .map((item) => ({
          label: item,
          score: this.scoreRoomSuggestion(item, normalizedQuery)
        }))
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))
        .slice(0, 5)
        .map((item) => item.label);
    }

    renderRoomSuggestions(roomId, query) {
      const suggestions = this.getRoomNameSuggestions(roomId, query);
      if (!suggestions.length) return '';

      return `
        <div
          class="ctm-dcssubmit_roomsuggestions"
          id="dcs-room-suggestions-${roomId}"
          role="listbox"
          data-dcssubmit-room-suggestions-wrap="${roomId}"
        >
          ${suggestions.map((suggestion) => `
            <button
              class="ctm-dcssubmit_roomsuggestion"
              type="button"
              role="option"
              data-dcssubmit-room-suggestion
              data-room-id="${roomId}"
              data-room-value="${this.escapeAttr(suggestion)}"
            >${suggestion}</button>
          `).join('')}
        </div>
      `;
    }

    updateRoomSuggestionsUI(roomId, options = {}) {
      const { forceHide = false } = options;
      const room = this.findRoom(roomId);
      const roomField = this.querySelector(`[data-dcssubmit-room-name="${roomId}"]`)?.closest('.ctm-dcssubmit_roomfield');
      const roomInput = this.querySelector(`[data-dcssubmit-room-name="${roomId}"]`);
      if (!room || !roomField || !roomInput) return;

      const existing = roomField.querySelector('[data-dcssubmit-room-suggestions-wrap]');
      if (existing) existing.remove();

      if (forceHide) {
        roomInput.setAttribute('aria-expanded', 'false');
        return;
      }

      const suggestionsMarkup = this.renderRoomSuggestions(roomId, room.name);
      if (suggestionsMarkup) {
        roomInput.insertAdjacentHTML('afterend', suggestionsMarkup);
        roomInput.setAttribute('aria-expanded', 'true');
      } else {
        roomInput.setAttribute('aria-expanded', 'false');
      }
    }

    updateRoomFieldUI(roomId) {
      const room = this.findRoom(roomId);
      const roomInput = this.querySelector(`[data-dcssubmit-room-name="${roomId}"]`);
      const roomField = roomInput?.closest('.ctm-dcssubmit_roomfield');
      if (!room || !roomInput || !roomField) return;

      roomInput.value = room.name || '';
      const errorKey = `room.${roomId}.name`;
      const error = this.state.errors[errorKey] || '';
      roomInput.setAttribute('aria-invalid', error ? 'true' : 'false');

      const existingError = roomField.querySelector('.ctm-dcssubmit_err');
      if (existingError) existingError.remove();

      if (error) {
        roomInput.setAttribute('aria-describedby', `dcs-room-${roomId}-err`);
        roomField.insertAdjacentHTML('beforeend', `<p class="ctm-dcssubmit_err" id="dcs-room-${roomId}-err">${error}</p>`);
      } else {
        roomInput.removeAttribute('aria-describedby');
      }

      if (this.activeRoomSuggestionRoomId === roomId && document.activeElement === roomInput) {
        this.updateRoomSuggestionsUI(roomId);
      } else {
        this.updateRoomSuggestionsUI(roomId, { forceHide: true });
      }
    }

    closeRoomSuggestions() {
      const roomId = this.activeRoomSuggestionRoomId;
      this.activeRoomSuggestionRoomId = null;
      this.querySelectorAll('[data-dcssubmit-room-suggestions-wrap]').forEach((suggestions) => {
        const suggestionsRoomId = suggestions.dataset.dcssubmitRoomSuggestionsWrap;
        suggestions.remove();
        const input = this.querySelector(`[data-dcssubmit-room-name="${suggestionsRoomId}"]`);
        if (input) input.setAttribute('aria-expanded', 'false');
      });
      if (roomId) this.updateRoomSuggestionsUI(roomId, { forceHide: true });
    }

    scoreRoomSuggestion(option, query) {
      const normalizedOption = String(option || '').trim().toLowerCase();
      if (!normalizedOption || !query) return 0;
      if (normalizedOption === query) return 100;
      if (normalizedOption.startsWith(query)) return 90 - (normalizedOption.length - query.length);
      if (normalizedOption.includes(query)) return 70 - normalizedOption.indexOf(query);

      const optionTokens = normalizedOption.split(/[\s/-]+/).filter(Boolean);
      const queryTokens = query.split(/[\s/-]+/).filter(Boolean);
      const matchedTokens = queryTokens.filter((token) => optionTokens.some((item) => item.startsWith(token) || item.includes(token))).length;
      return matchedTokens ? 30 + matchedTokens * 10 : 0;
    }

    resetFlow() {
      this.revokeObjectUrls();
      this.state = this.createInitialState();
      this.step = 1;
      this.isSubmitting = false;
      this.submitStatus = '';
      this.openDropdown = null;
      this.phoneCountryOpen = false;
      this.shouldFocusHeading = true;
      this.announce('');
      this.render();
    }

    syncLoadingState() {
      if (!this.form) return;

      const isBusy = this.isSubmitting && this.step !== 3;
      this.form.classList.toggle('is-submitting', isBusy);
      this.form.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      if (isBusy) {
        this.form.setAttribute('inert', '');
      } else {
        this.form.removeAttribute('inert');
      }
    }

    announce(message, isError = false) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.toggle('is-error', isError);
    }

    findRoom(roomId) {
      return this.state.rooms.find((room) => room.id === roomId);
    }

    findWindow(windowId) {
      for (const room of this.state.rooms) {
        const found = room.windows.find((windowItem) => windowItem.id === windowId);
        if (found) return found;
      }
      return null;
    }

    getByPath(path) {
      return path.split('.').reduce((value, key) => value?.[key], this.state);
    }

    setByPath(path, nextValue) {
      const keys = path.split('.');
      const lastKey = keys.pop();
      const target = keys.reduce((value, key) => value[key], this.state);
      target[lastKey] = nextValue;
    }

    revokeObjectUrls() {
      this.state.rooms.forEach((room) => {
        room.windows.forEach((windowItem) => {
          if (windowItem.photoUrl) URL.revokeObjectURL(windowItem.photoUrl);
        });
      });
      this.state.inspiration.forEach((photo) => {
        if (photo?.photoUrl) URL.revokeObjectURL(photo.photoUrl);
      });
    }

    escapeAttr(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    escapeHtml(value) {
      return this.escapeAttr(value).replace(/'/g, '&#39;');
    }

    iconTemplate(name) {
      return this.querySelector(`[data-dcssubmit-icon="${name}"]`);
    }

    getIconMarkup(name, fallback) {
      const template = this.iconTemplate(name);
      const markup = template?.innerHTML?.trim();
      return markup || fallback;
    }

    cameraIcon() {
      return this.getIconMarkup('camera', '<svg viewBox="0 0 24 24" focusable="false"><path d="M7 7l1.5-2h7L17 7h2a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h2zm5 10a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"/></svg>');
    }

    editIcon() {
      return this.getIconMarkup('edit', '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 17.5V21h3.5L18.1 10.4l-3.5-3.5L4 17.5zm16.8-9.9a1 1 0 000-1.4l-2-2a1 1 0 00-1.4 0l-1.5 1.5 3.5 3.5 1.4-1.6z"/></svg>');
    }

    uploadIcon() {
      return this.getIconMarkup('upload', '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 4l5 5h-3v6h-4V9H7l5-5zm-7 13h14v2H5v-2z"/></svg>');
    }

    trashIcon() {
      return this.getIconMarkup('trash', '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M8 21h8a2 2 0 002-2V7H6v12a2 2 0 002 2zM9 9h2v9H9V9zm4 0h2v9h-2V9zM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5z"/></svg>');
    }

    checkIcon() {
      return '<svg viewBox="0 0 24 24" focusable="false"><path d="M9.2 16.6L4.9 12.3l-1.4 1.4 5.7 5.7L21 7.6l-1.4-1.4L9.2 16.6z"/></svg>';
    }

    chevronIcon() {
      return '<svg viewBox="0 0 24 24" focusable="false"><path d="M7.4 8.6L12 13.2l4.6-4.6L18 10l-6 6-6-6 1.4-1.4z"/></svg>';
    }

    homeIcon() {
      return '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 4l8 7h-2v8h-5v-5h-2v5H6v-8H4l8-7zm0 2.7L8 10.2V17h1v-5h6v5h1v-6.8l-4-3.5z"/></svg>';
    }

    videoIcon() {
      return '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 6h11a2 2 0 012 2v1.5l3-2V17l-3-2v1a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2zm0 2v8h11V8H4z"/></svg>';
    }

    dropdownIcon(type) {
      if (type === 'palette') {
        return this.getIconMarkup('palette', '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 3a9 9 0 00-2 17.8c1 .2 1.6-.5 1.6-1.3 0-.5-.2-.9-.4-1.2-.4-.6 0-1.3.8-1.3h1.8A7.2 7.2 0 0021 9.8C21 6 17 3 12 3zM7.5 10A1.5 1.5 0 119 8.5 1.5 1.5 0 017.5 10zm3-3A1.5 1.5 0 1112 5.5 1.5 1.5 0 0110.5 7zm4 0A1.5 1.5 0 1116 5.5 1.5 1.5 0 0114.5 7zm2 4A1.5 1.5 0 1118 9.5a1.5 1.5 0 01-1.5 1.5z"/></svg>');
      }
      if (type === 'panel') {
        return this.getIconMarkup('curtain-panels', '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 5h16v14H4V5zm2 2v10h3V7H6zm5 0v10h2V7h-2zm4 0v10h3V7h-3z"/></svg>');
      }
      if (type === 'shade') {
        return this.getIconMarkup('curtain-panels', '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 4h14v16H5V4zm2 2v12h2V6H7zm4 0v12h2V6h-2zm4 0v12h2V6h-2z"/></svg>');
      }
      return '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 4h14v16H5V4zm2 2v12h2V6H7zm4 0v12h2V6h-2zm4 0v12h2V6h-2z"/></svg>';
    }
  }

  if (!customElements.get('ctm-dcs-submit')) {
    customElements.define('ctm-dcs-submit', CtmDcsSubmit);
  }
})();
